module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 赛事培训")])], 1), _vm._v(" "), _c('el-alert', {
    staticClass: "elalert",
    attrs: {
      "title": "温馨提示",
      "type": "error"
    }
  }, [_vm._v("\n            1.请先登陆单位会员帐号或注册（注意只对机构单位会员，个人会员无法报名）"), _c('br'), _vm._v("\n            2.请您确保在整个申报流程中，您所填写的信息属实。"), _c('br'), _vm._v("\n            3.申报需要官方后台审核，请您耐心等待。"), _c('br')]), _vm._v(" "), _c('el-collapse', {
    staticClass: "elcollapse",
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.groupList), function(group, index) {
    return _c('el-collapse-item', {
      key: index,
      attrs: {
        "title": group.name,
        "name": index
      }
    }, [_c('div', {
      staticClass: "elcollapse_group_desc"
    }, [_vm._v(_vm._s(group.desc))]), _vm._v(" "), _c('div', _vm._l((group.list), function(item, vindex) {
      return _c('div', {
        key: vindex,
        staticClass: "apply_and_name"
      }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
        staticClass: "apply_but"
      }, [_c('el-button', {
        attrs: {
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.goApply(item)
          }
        }
      }, [_vm._v("立即报名")])], 1)])
    }), 0)])
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示信息",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "报名须知",
      "name": "1"
    }
  }, [_c('p', [_vm._v("\n                        1.本考级是由EAE主办的全国艺术导师等级的官方考试，面向艺术教育工作者和在校大学生，从铜牌艺术导师、银牌艺术导师、金牌艺术导师、钻石艺术导师、国际艺术导师，共分五级。\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        2.正确填写考级报名表后，并完成缴费，在报名结果中提示“报名成功”，出现问题，请及时与“在线客服”联系。\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        3.本考级采用线下与线上相结合的方式。报名后既可参加由EAE授权的各省和横店影视城的集中培训，也可以免费自学本网站的开放课程，然后上线参加理论和实践考试。\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        4.考级原则从铜牌艺术导师开始；具备高校专业课讲师可以从金牌导师考起，具备高级职称的专业课教师可以从钻石导师考起。必须逐级参考。\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        5.从铜牌导师开始，可以同时参加“全国艺术表演评委”考试；获得金牌以上艺术导师时，同时自动获得“全国艺术表演评委”，全国艺术表演评委既可以获得艺术展演的评委资格，也兼备“少儿艺术表演考级”的评委资格。\n                    ")]), _vm._v(" "), _c('p', [_vm._v("6.从铜牌导师开始，将自动进入EAE艺术导师人才库。")]), _vm._v(" "), _c('p', [_vm._v("\n                        7.报考金牌导师以上，将集中由EAE线下培训与面考，理论测试仍在线上。\n                    ")])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "课程计划",
      "name": "2"
    }
  }, [_vm._v("课程计划")]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "考级培训",
      "name": "3"
    }
  }, [_vm._v("考级培训")]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "收费标准",
      "name": "4"
    }
  }, [_vm._v("收费标准")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goApply()
      }
    }
  }, [_vm._v("立即报名")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14a3ab16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/saishi/SaishiApplyIndex.vue
// module id = 1154
// module chunks = 0